import HexController from 'controllers/hex_controller';
import { v4 as uuidv4 } from 'uuid';

export default class extends HexController {
  static targets = ['cloneButton', 'hiddenSubmitButton'];

  connect() {
    this.cloneButtonTarget.addEventListener('click', this.cloneScript.bind(this));
    this.hiddenSubmitButtonTarget.addEventListener('click', this.submitForm.bind(this));
  }

  disconnect() {
    this.cloneButtonTarget.removeEventListener('click', this.cloneScript.bind(this));
    this.hiddenSubmitButtonTarget.removeEventListener('click', this.submitForm.bind(this));
  }

  cloneScript(event) {
    event.stopPropagation();
    event.preventDefault();
    if (window.navigationLockController._locking) {
      const funcName = uuidv4();
      window[funcName] = () => {
        this.cloneButtonTarget.click();
      };
      window.navigationLockController.showWarningDialog(null, `window['${funcName}']()`);
      return;
    }
    this._confirmCloneModal();
  }

  _confirmCloneModal() {
    const funcName = `MS_clone_${uuidv4()}`;
    window[funcName] = () => {
      this.hiddenSubmitButtonTarget.click();
    };
    const title = this.t('Clone Manual Script');
    const footer = `<button class='btn btn-link' onclick="Modalbox.hide();">${this.t('Cancel')}</button>`+
                   `<button class='btn btn-primary' onclick="Modalbox.hide(); window['${funcName}']()">${this.t('Confirm')}</button>`;
    const options = {
      title: title,
      width: 700,
      center: true,
      transitions: false,
      defaultFooter: true,
      footer: footer,
      // containerClass: 'no-container-padding'
    };
    const body = `<div>${this.t('Are you sure you want to clone this manual script?')}</div>`;
    Modalbox.show(body, options, footer);
  }

  submitForm(event) {
    event.stopPropagation();
  }
}